import { Link } from 'react-router-dom';
import { Mail, MapPin, Phone, ArrowUpRight, Facebook, Instagram, Linkedin } from 'lucide-react';

const Footer = () => {
  const socialLinks = [
    { name: 'Facebook', icon: Facebook, url: 'https://facebook.com/NextGenTechPath' },
    { name: 'Instagram', icon: Instagram, url: 'https://instagram.com/NextGenTechPath' },
    { name: 'LinkedIn', icon: Linkedin, url: 'https://linkedin.com/company/nextgentechpath' },
  ];

  return (
    <footer className="bg-[#0A1F44] border-t border-[#00AEEF]/20">
      <div className="max-w-7xl mx-auto px-6 lg:px-12 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Brand Column */}
          <div className="space-y-6">
            <Link to="/" className="flex items-center gap-3">
              <img 
                src="/logo.png" 
                alt="NextGen Tech Pathways" 
                className="h-14 w-auto"
              />
            </Link>
            <p className="text-[#94A3B8] text-sm leading-relaxed">
              A workforce development nonprofit using technology to create real career pathways for youth.
            </p>
            <p className="text-[#FF6A00] font-semibold text-sm">
              "We don't teach code. We build futures."
            </p>
            {/* Social Links */}
            <div className="flex items-center gap-4">
              {socialLinks.map((social) => (
                <a
                  key={social.name}
                  href={social.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-10 h-10 rounded-full bg-[#060F22] border border-[#00AEEF]/30 flex items-center justify-center text-[#94A3B8] hover:text-[#00FFE0] hover:border-[#00FFE0] transition-all"
                  aria-label={social.name}
                >
                  <social.icon className="w-5 h-5" />
                </a>
              ))}
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-white font-bold mb-6">Quick Links</h4>
            <ul className="space-y-3">
              {['About', 'Programs', 'Enrollment', 'Projects', 'Donate', 'Contact'].map((item) => (
                <li key={item}>
                  <Link
                    to={`/${item.toLowerCase()}`}
                    className="text-[#94A3B8] hover:text-[#00FFE0] transition-colors text-sm flex items-center gap-2"
                  >
                    <ArrowUpRight className="w-3 h-3" />
                    {item}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Programs */}
          <div>
            <h4 className="text-white font-bold mb-6">Programs</h4>
            <ul className="space-y-3">
              {['Web Development Foundations', 'App Development Track', 'Cloud & DevOps Intro', 'Demo Day Showcase'].map((item) => (
                <li key={item}>
                  <span className="text-[#94A3B8] text-sm">{item}</span>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-white font-bold mb-6">Contact Us</h4>
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <Mail className="w-5 h-5 text-[#00AEEF] mt-0.5" />
                <a href="mailto:info@nextgentechpath.org" className="text-[#94A3B8] hover:text-[#00FFE0] text-sm transition-colors">info@nextgentechpath.org</a>
              </li>
              <li className="flex items-start gap-3">
                <Phone className="w-5 h-5 text-[#00AEEF] mt-0.5" />
                <a href="tel:+12489566986" className="text-[#94A3B8] hover:text-[#00FFE0] text-sm transition-colors">(248) 956-6986</a>
              </li>
              <li className="flex items-start gap-3">
                <MapPin className="w-5 h-5 text-[#00AEEF] mt-0.5" />
                <span className="text-[#94A3B8] text-sm">Innovation Hub, Tech District</span>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-12 pt-8 border-t border-[#00AEEF]/20 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-[#94A3B8] text-sm">
            © {new Date().getFullYear()} NextGen Tech Pathways. All rights reserved.
          </p>
          <div className="flex items-center gap-6">
            <a href="#privacy" className="text-[#94A3B8] hover:text-[#00FFE0] text-sm transition-colors">
              Privacy Policy
            </a>
            <a href="#terms" className="text-[#94A3B8] hover:text-[#00FFE0] text-sm transition-colors">
              Terms of Service
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
